import React, {useEffect, useState} from 'react'
import logo from './logo.svg';
import './App.css';
import Posts from './components/posts/posts';
import PostLoadingComponent from './components/posts/postLoading'
import axiosInstance from './axios'

function App() {
  const PostLoading = PostLoadingComponent(Posts);
  const [appState, setAppState] = useState({
    loading:false,
    posts:null,
  });

  useEffect(() => {
    axiosInstance.get('/').then((res)=>{
      const allPosts = res.data;
      console.log(allPosts);
      setAppState({loading:false, posts:allPosts});
      console.log(res.data);
    });
  },[setAppState]);

  return (
    <div className='App'>
      <h1>Latest Posts</h1>
      <PostLoading isLoading={appState.loading} posts={appState.posts} />
    </div>
  )
}

export default App;
